import { Select } from '@material-ui/core';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  min-width: 9em;
  margin: 0;
  background: transparent;
`;
